<template>
  <div class="c-product-list">

    <div class="list-title">{{ productListName }}</div>

    <ControlBox title="选择商品列表" v-if="showController">
      <el-form @submit.native.prevent>
        <c-select v-bind="selectProps" @change="handleChange" />
      </el-form>
    </ControlBox>
  </div>
</template>

<script>
import { Vue, Component, Model, Prop } from 'vue-property-decorator';
import ControlBox from '../control-box';
import _ from 'lodash';

@Component({
  components: {
    ControlBox
  }
})
export default class ProductList extends Vue {
  @Model('change', { type: Object, default: () => ({
    data: [
      {
        key: ''
      }
    ],
    config: {}
  }) }) value;
  @Prop(Boolean) showController;
  @Prop(Array) tabModules;

  get tabModuleKey() {
    return this.value.data[0].key;
  }

  get selectProps() {
    return {
      value: this.tabModuleKey,
      options: this.tabModules.map(({ key, name }) => ({ value: key, label: name }))
    }
  }

  get productListName() {
    return _.get(this.tabModules.find(item => item.key === this.tabModuleKey), 'name');
  }

  mounted() {
    this.syncChange();
  }

  syncChange() {
    this.$emit('change', this.value);
  }

  handleChange(val) {
    this.$set(this.value.data[0], 'key', val);
    this.syncChange();
  }
}
</script>

<style lang="scss" scoped>
  .list-title {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
</style>
